import React, {ReactElement, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IQuestionReportElement} from '../../../../../incase-domain/elements/question/questionReportElement';
import RenderQuestionReport from './RenderQuestionReport';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {loadedPresentationSelector} from '../../../../../store/selectors/presentation.selectors';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';
import {useQuestionReportData} from '../../../../../hooks/useQuestionReportData';
import ElementLoadingSkeleton from '../../../../../incase-domain/components/loadingSkeleton/ElementLoadingSkeleton';

interface QuestionReportElementProps {
    element: IQuestionReportElement;
    device: DeviceType;
}

// TODO: Question can be on slide that is hidden by rules. So we need to fix that (get state before applying rules)
function QuestionReportElement({element, device}: QuestionReportElementProps): ReactElement | null {
    const loadedPresentation = useSelector(loadedPresentationSelector);

    const questionReport = useQuestionReportData(element.questionElementId);

    const actualQuestionElement = useMemo(() => {
        if (!element.questionElementId || !loadedPresentation?.slides) {
            return null;
        }

        const slideId = element.questionElementId.split('-')[0];
        const targetSlide = loadedPresentation.slides.find((slide) => slide._id === slideId);
        if (targetSlide?.elements) {
            const foundElement = targetSlide.elements.find((el) => 'id' in el && el.id === element.questionElementId) as
                | IElementQuestionnaire
                | undefined;

            if (foundElement) {
                return foundElement;
            }
        }
        return null;
    }, [element.questionElementId, loadedPresentation?.slides]);

    if (!questionReport) {
        return <ElementLoadingSkeleton />;
    }

    return (
        <RenderQuestionReport
            questionReport={questionReport}
            question={actualQuestionElement as IQuestionElements}
            device={device}
            fontFamily={element.fontFamily}
        />
    );
}

export default QuestionReportElement;
